import { useCallback, useState } from 'react';
import { useNotify, useRedirect } from 'react-admin';
import { API_BASE_URL_ADMIN } from 'shared/config';
import { API_URL } from 'shared/constants/api-url';
import { httpClient } from 'shared/services/http-client';
import { resolveDeletePatientProfileError } from './lib/resolve-delete-error';

export const useDeletePatientProfile = (patientId?: string) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteProfile = useCallback(async (): Promise<boolean> => {
    if (!patientId) {
      return false;
    }

    setIsDeleting(true);
    setError(null);

    try {
      await httpClient(`${API_BASE_URL_ADMIN}${API_URL.patientDelete(patientId)}`, {
        method: 'DELETE',
      });

      notify('Профиль клиента удалён', { type: 'success' });
      redirect('/patients');
      return true;
    } catch (e) {
      const message = resolveDeletePatientProfileError(e);
      setError(message);
      notify(message, { type: 'error' });
      return false;
    } finally {
      setIsDeleting(false);
    }
  }, [notify, patientId, redirect]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    deleteProfile,
    isDeleting,
    error,
    clearError,
  };
};
